import { LogoWordmark } from '@cbhq/cds-web/icons/LogoWordmark'

import { Div } from './Div'

export function CoinbaseLogo() {
  return (
    <Div as="span" display="contents">
      <LogoWordmark />
    </Div>
  )
}
